import { useMutation } from "react-query";
import checklistService from "../services/checklistService";

const useChecklistActionMutation = (onData) => {
    return useMutation(checklistService.checklistAction, {
        onSuccess: (data) => onData(data),
    });
};

const checklistQueries = {
    useChecklistActionMutation
};

export default checklistQueries;
